var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pageToast',{attrs:{"msg":_vm.msg}})
}
var staticRenderFns = []

export { render, staticRenderFns }